import React from 'react';
import PropTypes from 'prop-types';
import PeriodoVigenciaItem from './PeriodoVigenciaItem';
import { DataGrid } from '../index';

const PeriodosVigenciaControl = (props) => {
  // const pesquisarCadprev = (
  //   <Button
  //     title="Atualizar períodos CADPREV"
  //     onClick={() => props.handleSearchPesquisaCadPrevButton()}
  //     hint="Atualizar períodos CADPREV"
  //   />
  // );

  const handleItens = () => {
    const mappedPeriodos = props.periodosVigencia;
    const periodos = [];
    if (mappedPeriodos) {
      mappedPeriodos.forEach((item) => {
        periodos.push(<PeriodoVigenciaItem
          periodo={item}
        />);
      });
    }
    return periodos;
  };

  return props.periodosVigencia.length > 0 ? (
    <DataGrid title="Períodos de RPPS" icon="ico-doc-book" >
      {/* {pesquisarCadprev} */}
      {handleItens()}
    </DataGrid>
  ) : null;
};

PeriodosVigenciaControl.propTypes = {
  // handleSearchPesquisaCadPrevButton: PropTypes.func.isRequired,
  periodosVigencia: PropTypes.arrayOf(PropTypes.shape({
    cnpj: PropTypes.string,
    dataCriacaoRpps: PropTypes.string,
    dataEncerramentoRpps: PropTypes.string,
  })).isRequired,
};

export default PeriodosVigenciaControl;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/PeriodosVigenciaControl.jsx